<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

@if (parentDirectory !== undefined) {
  <div>
    @if (parentDirectoryUI$ | async; as parentDirectoryUI) {
      <mat-accordion>
        <mat-expansion-panel
          class="mat-elevation-z0"
          [expanded]="parentDirectoryUI.isExpanded"
          >
          <mat-expansion-panel-header
            (click)="toggleIsExpanded(parentDirectoryUI)"
        (contextmenu)="
          onContextMenu($event, parentDirectory, ProjectObjectType.DIRECTORY)
        "
            >
            <mat-panel-title>
              <div class="d-flex flex-row justify-content-start align-items-center">
                <mat-icon class="mdi-18px" fontIcon="mdi-folder"></mat-icon>
                <strong>{{ parentDirectory.name }}</strong>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-accordion>
            <mat-expansion-panel
              class="mat-elevation-z0"
              [expanded]="parentDirectoryUI.isFilesExpanded"
              >
              <mat-expansion-panel-header
                (click)="toggleIsFilesExpanded(parentDirectoryUI)"
                >
                <mat-panel-title>
                  <span
                    MatBadgeSize="small"
                    matBadge="{{ (parentFiles$ | async).length }}"
                    matBadgeOverlap="false"
                    class="panel-header"
                    ><strong>FILES</strong></span
                    >
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list>
                  @for (obj of files$ | async | filesFilter: null; track obj.id) {
                    <mat-list-item
                      (contextmenu)="onContextMenu($event, obj, ProjectObjectType.FILE)"
                      >
                      @if (obj.lockedById === null && !obj.administrativelyLocked) {
                        <div
                          class="highlight d-flex flex-row justify-content-start align-items-center w-100 h-100"
                          style="margin-left: 2%"
                          >
                          <mat-icon
                            class="mdi-18px show-pointer"
                            fontIcon="mdi-file"
                            (click)="openFile(obj)"
                          ></mat-icon>
                          <a class="link-text" (click)="openFile(obj)">{{ obj.name }}</a>
                        </div>
                      }
                      @if (obj.lockedById !== null && !obj.administrativelyLocked) {
                        <div
                          class="highlight d-flex flex-row justify-content-start align-items-center w-100 h-100"
                          style="margin-left: 2%"
                          >
                          <mat-icon
                            class="mdi-18px show-pointer"
                            fontIcon="mdi-file-hidden"
                            (click)="openFile(obj)"
                          ></mat-icon>
                          <a
                            class="link-locked-text disabled-text"
                            (click)="openFile(obj)"
                            matTooltip="{{ obj.lockedByName }} is editing this file"
                            >{{ obj.name }}</a
                            >
                          </div>
                        }
                        @if (obj.administrativelyLocked) {
                          <div
                            class="highlight d-flex flex-row justify-content-start align-items-center w-100 h-100"
                            style="margin-left: 2%"
                            >
                            <mat-icon
                              class="mdi-18px show-pointer"
                              fontIcon="mdi-file-lock"
                              (click)="openFile(obj)"
                            ></mat-icon>
                            <a
                              class="link-locked-text disabled-text"
                              (click)="openFile(obj)"
                              matTooltip="Administratively locked"
                              >{{ obj.name }}</a
                              >
                            </div>
                          }
                        </mat-list-item>
                      }
                      @if (canEdit$ | async) {
                        <mat-list-item>
                          <div class="d-flex flex-row justify-content-start align-items-center" style="margin-left: 2%">
                            <mat-icon
                              (click)="createFile(parentDirectory.id)"
                              matTooltip="Add New File to {{ parentDirectory.name }}"
                              class="icon-space mdi-18px"
                              fontIcon="mdi-file-plus-outline"
                            ></mat-icon>
                            <a
                              class="add-link-text"
                              matTooltip="Add New File to {{ parentDirectory.name }}"
                              (click)="createFile(parentDirectory.id)"
                              >
                              Add File
                            </a>
                          </div>
                        </mat-list-item>
                      }
                    </mat-list>
                  </mat-expansion-panel>
                </mat-accordion>
                <mat-divider></mat-divider>
                <mat-accordion>
                  <mat-expansion-panel
                    class="mat-elevation-z0"
                    [expanded]="parentDirectoryUI.isWorkspacesExpanded"
                    >
                    <mat-expansion-panel-header
                      (click)="toggleIsWorkspacesExpanded(parentDirectoryUI)"
                      >
                      <mat-panel-title>
                        <span
                          MatBadgeSize="small"
                          matBadge="{{ (workspaces$ | async).length }}"
                          matBadgeOverlap="false"
                          class="panel-header"
                          ><strong>WORKSPACES</strong></span
                          >
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <mat-accordion multi="true">
                        @for (obj of workspaces$ | async; track obj.id) {
                          <mat-expansion-panel
                            class="mat-elevation-z0"
                            [expanded]="isWorkspaceExpanded(obj.id)"
                            >
                            <mat-expansion-panel-header
                              (click)="toggleIsWorkspaceExpanded(obj.id)"
                (contextmenu)="
                  onContextMenu($event, obj, ProjectObjectType.WORKSPACE)
                "
                              >
                              <mat-panel-title>
                                <mat-icon
                                  class="icon-space mdi-18px"
                                  (click)="$event.stopPropagation(); openWorkspace(obj)"
                                  fontIcon="mdi-briefcase"
                                ></mat-icon>
                                <a
                                  class="link-text"
                                  (click)="$event.stopPropagation(); openWorkspace(obj)"
                                  >{{ obj.name }}</a
                                  >
                                </mat-panel-title>
                              </mat-expansion-panel-header>
                              <mat-list>
                                @for (file of files$ | async | filesFilter: obj.id; track file.id) {
                                  <mat-list-item
                  (contextmenu)="
                    onContextMenu($event, file, ProjectObjectType.FILE)
                  "
                                    >
                                    @if (
                                      file.lockedById === null && !file.administrativelyLocked
                                      ) {
                                      <div
                                        class="highlight d-flex flex-row justify-content-start align-items-center w-100 h-100"
                                        style="margin-left: 10%"
                                        >
                                        <mat-icon class="mdi-18px" fontIcon="mdi-file"></mat-icon>
                                        <a class="link-text" (click)="openFile(file)">{{
                                          file.name
                                        }}</a>
                                      </div>
                                    }
                                    @if (
                                      file.lockedById !== null && !file.administrativelyLocked
                                      ) {
                                      <div
                                        class="highlight d-flex flex-row justify-content-start align-items-center w-100 h-100"
                                        style="margin-left: 10%"
                                        >
                                        <mat-icon
                                          class="mdi-18px"
                                          fontIcon="mdi-file-lock"
                                        ></mat-icon>
                                        <a
                                          class="link-locked-text disabled-text"
                                          (click)="openFile(file)"
                                          matTooltip="{{ file.lockedByName }} is editing this file"
                                          >{{ file.name }}</a
                                          >
                                        </div>
                                      }
                                      @if (file.administrativelyLocked) {
                                        <div
                                          class="highlight d-flex flex-row justify-content-start align-items-center w-100 h-100"
                                          style="margin-left: 10%"
                                          >
                                          <mat-icon
                                            class="mdi-18px"
                                            fontIcon="mdi-file-hidden"
                                          ></mat-icon>
                                          <a
                                            class="link-locked-text disabled-text"
                                            (click)="openFile(file)"
                                            matTooltip="Adminstratively locked"
                                            >{{ file.name }}</a
                                            >
                                          </div>
                                        }
                                      </mat-list-item>
                                    }
                                    @if (canEdit$ | async) {
                                      <mat-list-item>
                                        <div
                                          class="d-flex flex-row justify-content-start align-items-center"
                                          style="margin-left: 10%"
                                          >
                                          <mat-icon
                                            (click)="createFile(parentDirectory.id, obj.id)"
                                            title="Add New File to workspace {{ obj.name }}"
                                            class="icon-space mdi-18px"
                                            fontIcon="mdi-file-plus-outline"
                                            matTooltip="Add New File to Workspace {{ obj.name }}"
                                          ></mat-icon>
                                          <a
                                            class="add-link-text"
                                            matTooltip="Add New File to Workspace {{ obj.name }}"
                                            (click)="createFile(parentDirectory.id, obj.id)"
                                            >Add Workspace File</a
                                            >
                                          </div>
                                        </mat-list-item>
                                      }
                                    </mat-list>
                                  </mat-expansion-panel>
                                }
                              </mat-accordion>
                              @if (canEdit$ | async) {
                                <div
                                  class="add-new-text d-flex flex-row justify-content-start align-items-center"
                                  >
                                  <mat-icon
                                    (click)="createWorkspace()"
                                    title="Add New Workspace to {{ parentDirectory.name }}"
                                    class="icon-space mdi-18px"
                                    fontIcon="mdi-plus-box-outline"
                                    matTooltip="Add New Workspace to {{ parentDirectory.name }}"
                                  ></mat-icon>
                                  <a
                                    class="add-link-text"
                                    matTooltip="Add New Workspace to {{ parentDirectory.name }}"
                                    (click)="createWorkspace()"
                                    >Add Workspace</a
                                    >
                                  </div>
                                }
                              </mat-expansion-panel>
                            </mat-accordion>
                            <mat-divider></mat-divider>
                            <mat-accordion>
                              <mat-expansion-panel
                                class="mat-elevation-z0"
                                [expanded]="parentDirectoryUI.isDirectoriesExpanded"
                                >
                                <mat-expansion-panel-header
                                  (click)="toggleIsDirectoriesExpanded(parentDirectoryUI)"
                                  >
                                  <mat-panel-title>
                                    <span
                                      MatBadgeSize="small"
                                      matBadge="{{ (directories$ | async).length }}"
                                      matBadgeOverlap="false"
                                      class="panel-header"
                                      ><strong>DIRECTORIES</strong></span
                                      >
                                    </mat-panel-title>
                                  </mat-expansion-panel-header>
                                  @for (obj of directories$ | async; track obj.id) {
                                    <cas-directory-panel
                                      [parentDirectory]="obj"
                                      >
                                    </cas-directory-panel>
                                  }
                                  @if (canEdit$ | async) {
                                    <div
                                      class="add-new-text d-flex flex-row justify-content-start align-items-center"
                                      >
                                      <mat-icon
                                        (click)="createNewDirectory(parentDirectory.id)"
                                        title="Add New Directory to {{ parentDirectory.name }}"
                                        class="icon-space mdi-18px"
                                        fontIcon="mdi-folder-plus-outline"
                                        matTooltip="Add New Directory to {{ parentDirectory.name }}"
                                      ></mat-icon>
                                      <a
                                        class="add-link-text"
                                        (click)="createNewDirectory(parentDirectory.id)"
                                        matTooltip="Add New Directory to {{ parentDirectory.name }}"
                                        >Add Directory</a
                                        >
                                      </div>
                                    }
                                  </mat-expansion-panel>
                                </mat-accordion>
                                <mat-divider></mat-divider>
                                <mat-accordion>
                                  <mat-expansion-panel
                                    class="mat-elevation-z0"
                                    [expanded]="parentDirectoryUI.isDesignsExpanded"
                                    >
                                    <mat-expansion-panel-header
                                      (click)="toggleIsDesignsExpanded(parentDirectoryUI)"
                                      >
                                      <mat-panel-title>
                                        <span
                                          MatBadgeSize="small"
                                          matBadge="{{ (designs$ | async).length }}"
                                          matBadgeOverlap="false"
                                          class="panel-header"
                                          ><strong>DESIGNS</strong></span
                                          >
                                        </mat-panel-title>
                                      </mat-expansion-panel-header>
                                      <mat-list>
                                        @for (obj of designs$ | async; track obj.id) {
                                          <mat-list-item
              (contextmenu)="
                onContextMenu($event, obj, ProjectObjectType.DESIGN)
              "
                                            >
                                            <div
                                              [ngClass]="obj.enabled ? '' : 'disabled-text'"
                                              [matTooltip]="obj.enabled ? '' : 'Disabled'"
                                              class="highlight d-flex flex-row justify-content-start align-items-center w-100 h-100"
                                              style="margin-left: 2%"
                                              >
                                              <mat-icon
                                                class="mdi-18px show-pointer"
                                                fontIcon="mdi-file"
                                                (click)="openDesign(obj)"
                                              ></mat-icon>
                                              <a class="link-text" (click)="openDesign(obj)">{{
                                                obj.name
                                              }}</a>
                                            </div>
                                          </mat-list-item>
                                        }
                                        @if (canEdit$ | async) {
                                          <mat-list-item>
                                            <div class="d-flex flex-row justify-content-start align-items-center" style="margin-left: 2%">
                                              <mat-icon
                                                (click)="createDesign(parentDirectory.id)"
                                                matTooltip="Add New Design to {{ parentDirectory.name }}"
                                                class="icon-space mdi-18px"
                                                fontIcon="mdi-file-plus-outline"
                                              ></mat-icon>
                                              <a
                                                class="add-link-text"
                                                matTooltip="Add New Design to {{ parentDirectory.name }}"
                                                (click)="createDesign(parentDirectory.id)"
                                                >
                                                Add Design
                                              </a>
                                            </div>
                                          </mat-list-item>
                                        }
                                      </mat-list>
                                    </mat-expansion-panel>
                                  </mat-accordion>
                                </mat-expansion-panel>
                              </mat-accordion>
                            }
                          </div>
                        }

                        <div
                          style="visibility: hidden; position: fixed"
                          [style.left]="contextMenuPosition.x"
                          [style.top]="contextMenuPosition.y"
                          [matMenuTriggerFor]="contextMenu"
                        ></div>

                        <mat-menu #contextMenu="matMenu">
                          <ng-template matMenuContent let-item="item">
                            @if (canEnable(item)) {
                              <button
                                [disabled]="!(canEdit$ | async)"
                                mat-menu-item
                                (click)="onContextEnable(item)"
                                class="d-flex flex-row"
                                >
                                {{ item.object.enabled ? 'Disable' : 'Enable' }}
                              </button>
                            }
                            @if (canRename(item)) {
                              <button
                                [disabled]="!(canEdit$ | async)"
                                mat-menu-item
                                (click)="onContextRename(item)"
                                class="d-flex flex-row"
                                >
                                Rename
                              </button>
                            }
                            @if (canEdit(item)) {
                              <button
                                [disabled]="!(canEdit$ | async)"
                                mat-menu-item
                                (click)="onContextEdit(item)"
                                class="d-flex flex-row"
                                >
                                Edit
                              </button>
                            }
                            <button
                              [disabled]="!(canEdit$ | async)"
                              mat-menu-item
                              (click)="onContextDelete(item)"
                              class="d-flex flex-row"
                              >
                              Delete
                            </button>
                            @if (isExportable(item)) {
                              <button
                                mat-menu-item
                                (click)="onContextExport(item)"
                                class="d-flex flex-row"
                                >
                                Export
                              </button>
                            }
                            @if (isExportable(item)) {
                              <button
                                mat-menu-item
                                (click)="onContextImport(item)"
                                class="d-flex flex-row"
                                >
                                Import
                              </button>
                            }
                          </ng-template>
                        </mat-menu>

                        <ng-template #exportDialog>
                          <cas-project-export
                            [id]="exportId"
                            [type]="exportObjectType"
                            [name]="exportName"
                            (exportComplete)="onExportComplete()"
                            >
                          </cas-project-export>
                        </ng-template>

                        <ng-template #importDialog>
                          <cas-project-import
                            [id]="exportId"
                            [type]="exportObjectType"
                            [name]="exportName"
                            (importComplete)="onImportComplete()"
                            >
                          </cas-project-import>
                        </ng-template>

                        <ng-template #workspaceEditDialog>
                          <cas-workspace-edit-container
                            [id]="editingWorkspaceId"
                            (editWorkspaceComplete)="onEditWorkspaceComplete()"
                            >
                          </cas-workspace-edit-container>
                        </ng-template>

                        <ng-template #directoryEditDialog>
                          <cas-directory-edit-container
                            [id]="editingDirectoryId"
                            (editDirectoryComplete)="onEditDirectoryComplete()"
                            >
                          </cas-directory-edit-container>
                        </ng-template>
